/**
 * Path to a list's copywriting/campaign-builder page with a specific campaign pre-selected.
 * The page reads `campaign` (name) + `campaignUuid` from the query string and auto-opens that
 * campaign's builder (see ListEditCopywriting).
 */
export const buildCampaignBuilderPath = (
	listId: number,
	campaign: { name: string; campaignId: string }
): string =>
	`/app/lists/create/copywriting/${listId}?campaign=${encodeURIComponent(
		campaign.name
	)}&campaignUuid=${campaign.campaignId}`;
